import {
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Loader,
  LoadingOverlay,
  rem,
  Select,
  Text,
  TextInput,
  Title,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useDebouncedState, useDisclosure, useHotkeys } from "@mantine/hooks";
import {
  IconBrandBootstrap,
  IconBuildingWarehouse,
  IconCalendar,
  IconFileExport,
  IconSearch,
  IconStatusChange,
  IconTicket,
  IconUserCheck,
  IconUserCode,
  IconUserEdit,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useDeferredValue, useEffect, useState } from "react";
import {
  keySearchSalesReportByProduct,
  repositoryDelivery,
  repositoryMdm,
} from "../../../../_base/_const/_constVar";
import _breadcrumb from "../../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import {
  changeSearchValue,
  getValueById,
} from "../../../../_base/helper/FunctionHelper";
import {
  formatDateNotTimeZone,
  formatDateTransfer,
} from "../../../../common/FormatDate/FormatDate";
import { _localization } from "../../../../config/location";
import {
  green,
  olive_green,
  orange,
  sky_blue,
} from "../../../../const/variables";
import { MessageResponse } from "../../../../model/MessageResponse";
import { getMasterOrgSelect } from "../../../../service/getSelectApi";
import { BASE_API_MDM } from "../../../../config";

type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

const SalesReportByProduct = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 50,
  });
  const rowSelectionDeferred =
    useDeferredValue<MRT_RowSelectionState>(rowSelection);
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [visible, { toggle, open, close }] = useDisclosure(false);
  const [isCallFirst, setIsCallFirst] = useState<boolean>(false);
  const userLoginHeader = JSON.parse(
    localStorage.getItem("userLoginHeader") || "{}",
  );

  const [dataBranch, setDataBranch] = useState<any[]>([]);
  const [selectIdBranch, setSelectIdBranch] = useState<string[]>([]);
  const [dataInv, setDataInv] = useState<any[]>([]);

  const _searchJson = localStorage.getItem(keySearchSalesReportByProduct)
    ? JSON.parse(localStorage.getItem(keySearchSalesReportByProduct) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") === "true";
  const [search, setSearch] = useState<any>({
    FromDate:
      _searchJson && checkedPinSearch
        ? new Date(_searchJson?.FromDate)?.toISOString()
        : new Date(
            new Date(new Date().setMonth(new Date().getMonth() - 1)).getTime() +
              7 * 60 * 60 * 1000,
          )?.toISOString(),
    ToDate:
      _searchJson && checkedPinSearch
        ? new Date(_searchJson?.ToDate)?.toISOString()
        : new Date(new Date().getTime() + 7 * 60 * 60 * 1000).toISOString(),
    MaCn: _searchJson && checkedPinSearch ? _searchJson?.MaCn?.toString() : "",
    MaKho:
      _searchJson && checkedPinSearch ? _searchJson?.MaKho?.toString() : "",
  });
  const [keySearch, setKeySearch] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
    300,
  );
  const [OrderNumber, setOrderNumber] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.OrderNumber : "",
    300,
  );
  const [MaKh, setMaKh] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.MaKh : "",
    300,
  );
  const [TenKh, setTenKh] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.TenKh : "",
    300,
  );
  const [MaNvkd, setMaNvkd] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.MaNvkd : "",
    300,
  );
  const [FromTongTien, setFromTongTien] = useDebouncedState<number>(
    _searchJson && checkedPinSearch ? Number(_searchJson?.FromTongTien) : 0,
    300,
  );
  const [ToTongTien, setToTongTien] = useDebouncedState<number>(
    _searchJson && checkedPinSearch ? Number(_searchJson?.ToTongTien) : 0,
    300,
  );

  const orderStatuses = [
    { value: "DON_HANG_TAM", label: "Đơn hàng tạm" },
    { value: "DON_HANG_CHOT", label: "Đơn hàng chốt" },
    { value: "DON_HANG_CHO_DUYET_GIAM", label: "Đơn chờ duyệt giảm" },
    { value: "DON_HANG_DA_DUYET_GIAM", label: "Đơn đã duyệt giảm" },
    { value: "DON_HANG_HUY", label: "Đơn hàng hủy" },
    { value: "DON_HANG_HOAN_THANH", label: "Đơn hàng hoàn thành" },
    { value: "DON_HANG_DONG", label: "Đơn hàng đóng" },
  ];

  const dataStatusGeneral = [
    { label: "Kho xuất hàng", value: "KHO_XUAT_HANG" },
    { label: "Thành công", value: "THANH_CONG" },
    { label: "Test OK", value: "TEST_OK" },
    { label: "Đơn hàng hoàn thành", value: "DON_HANG_HOAN_THANH" },
    { label: "Đơn hàng tạm", value: "DON_HANG_TAM" },
    { label: "Thất bại do KH", value: "THAT_BAI_DO_KH" },
    { label: "KTKT đang kiểm tra", value: "KTKT_DANG_KIEM_TRA" },
    { label: "Đơn hàng chờ duyệt giảm", value: "DON_HANG_CHO_DUYET_GIAM" },
    { label: "GV thành công", value: "GV_THANH_CONG" },
    { label: "Nhập lại", value: "NHAP_LAI" },
    { label: "Đã phân công GV", value: "DA_PHAN_CONG_GV" },
    { label: "GV đến nơi", value: "GV_DEN_NOI" },
    { label: "GV đang giao", value: "GV_DANG_GIAO" },
    { label: "Test lỗi", value: "TEST_LOI" },
    { label: "Đã phân công KTKT", value: "DA_PHAN_CONG_KTKT" },
    { label: "Hủy phân công GV", value: "HUY_PHAN_CONG_GV" },
    { label: "Thất bại do HACOM", value: "THAT_BAI_DO_HACOM" },
    { label: "Nhập lại một phần", value: "NHAP_LAI_MOT_PHAN" },
    { label: "Đơn hàng chốt", value: "DON_HANG_CHOT" },
    { label: "Đơn hàng đã duyệt giảm", value: "DON_HANG_DA_DUYET_GIAM" },
    { label: "GV tiếp nhận", value: "GV_TIEP_NHAN" },
    { label: "GV nhập lại", value: "GV_NHAP_LAI" },
    { label: "GV nhập lại một phần", value: "GV_NHAP_LAI_MOT_PHAN" },
    { label: "GV thất bại do HACOM", value: "GV_THAT_BAI_DO_HACOM" },
    { label: "GV thất bại do KH", value: "GV_THAT_BAI_DO_KH" },
    { label: "GV nối chuyến", value: "GV_NOI_CHUYEN" },
    { label: "Hủy phân công KTKT", value: "HUY_PHAN_CONG_KTKT" },
    { label: "KH đã nhận", value: "DA_NHAN" },
  ];

  const dataStatusDelivery = [
    { label: "Đã phân công", value: "PHAN_CONG" },
    { label: "Lập đơn giao hàng", value: "TAO_MOI" },
    { label: "Đang giao hàng", value: "DANG_GIAO" },
    { label: "Đã đến nơi", value: "DEN_NOI" },
    {
      label: "Đơn hàng giao chưa thành công do Khách hàng",
      value: "THAT_BAI_DO_KH",
    },
    {
      label: "Đơn hàng giao chưa thành công do Hacom",
      value: "THAT_BAI_DO_HACOM",
    },
    { label: "Hàng đã giao", value: "THANH_CONG" },
    { label: "Tiếp nhận", value: "TIEP_NHAN" },
    { label: "Hủy phân công", value: "HUY_PHAN_CONG" },
    { label: "Hủy đơn", value: "HUY_DON" },
    { label: "Nối chuyến", value: "NOI_CHUYEN" },
    { label: "Nhập lại toàn bộ", value: "NHAP_LAI" },
    { label: "Nhập lại một phần", value: "NHAP_LAI_MOT_PHAN" },
  ];

  const dataStatusOption = [
    { value: "TAO_MOI", label: "Tạo mới" },
    { value: "PHAN_CONG", label: "Phân công" },
    // { value: "TIEP_NHAN", label: "Tiếp nhận" },
    { value: "DANG_KIEM_TRA", label: "Đang kiểm tra" },
    // { value: "DA_KIEM_TRA", label: "Đã kiểm tra" },
    { value: "TEST_MOT_PHAN", label: "Test một phần" },
    { value: "TEST_LOI", label: "Test lỗi" },
    { value: "TEST_OK", label: "Test ok" },
    { value: "HUY_PHAN_CONG", label: "Hủy phân công" },
    // { value: "THANH_CONG", label: "Thành công" },
    // { value: "THAT_BAI", label: "Thất bại" },
  ];

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "ma_Ct",
        header: "Mã chứng từ",
        Cell: ({ renderedCellValue }) => (
          <Badge
            radius="sm"
            variant="dot"
            size="lg"
            color={renderedCellValue === null ? "red" : green.base}
          >
            {renderedCellValue}
          </Badge>
        ),
      },
      { accessorKey: "ngay_Ct", header: "Ngày chứng từ" },
      { accessorKey: "ngay_Hach_Toan", header: "Ngày hạch toán" },
      {
        accessorKey: "ghi_Chu_Don_Hang",
        header: "Ghi chú đơn hàng",
        size: 300,
      },
      { accessorKey: "ghi_Chu_Ke_Toan", header: "Ghi chú kế toán", size: 300 },
      {
        accessorKey: "trang_Thai_Hd",
        header: "Trạng thái đơn hàng",
        Cell: ({ row }) => {
          const orderStatus = row.original.trang_Thai_Hd;
          let badgeColor;
          switch (orderStatus) {
            case "DON_HANG_TAM":
              badgeColor = "cyan";
              break;
            case "DON_HANG_CHOT":
              badgeColor = "violet";
              break;
            case "DON_HANG_DOI_TRA_TAM":
              badgeColor = "cyan";
              break;
            case "DON_HANG_HOAN_THANH":
              badgeColor = "green";
              break;
            case "DON_HANG_DOI_TRA":
              badgeColor = "green";
              break;
            case "THANH_TOAN_CHUA_HOAN_THANH":
              badgeColor = "red";
              break;
            case "pending":
              badgeColor = "yellow";
              break;
            case "DON_HANG_BAN_TAI_SHOP":
              badgeColor = "green";
              break;
            case "DON_HANG_CHO_DUYET_GIAM":
              badgeColor = olive_green.light;
              break;
            case "DON_HANG_DA_DUYET_GIAM":
              badgeColor = olive_green.medium;
              break;
            case "KHO_XUAT_HANG":
              badgeColor = sky_blue.medium;
              break;
            case "DON_HANG_DONG":
              badgeColor = "red";
              break;
            default:
              badgeColor = "gray";
          }
          return (
            <Badge
              size="md"
              color={badgeColor}
              fs={"12,5px"}
              fw={"bold"}
              radius="sm"
            >
              {getValueById(row.original.trang_Thai_Hd, orderStatuses, "label")}
            </Badge>
          );
        },
        size: 225,
      },
      { accessorKey: "ma_Cn", header: "Mã chi nhánh" },
      { accessorKey: "ten_Cn", header: "Tên chi nhánh" },
      { accessorKey: "ten_Bp", header: "Tên bộ phận" },
      { accessorKey: "ma_Kho", header: "Mã kho" },
      { accessorKey: "ten_Kho", header: "Tên kho" },
      { accessorKey: "ma_Nvkd", header: "Mã nhân viên KD" },
      { accessorKey: "ten_Nvkd", header: "Tên nhân viên KD" },
      {
        accessorKey: "ma_Nguoi_Huong_So",
        header: "Mã người hưởng số",
        size: 200,
      },
      {
        accessorKey: "ten_Nguoi_Huong_So",
        header: "Tên người hưởng số",
        size: 200,
      },
      { accessorKey: "ma_Ql", header: "Mã quản lý" },
      { accessorKey: "ten_Ql", header: "Tên quản lý" },
      { accessorKey: "ma_Kt", header: "Mã kế toán" },
      { accessorKey: "ten_Ke_Toan", header: "Tên kế toán" },
      { accessorKey: "ma_Kenh", header: "Mã kênh" },
      { accessorKey: "ten_Kenh", header: "Tên kênh" },
      { accessorKey: "ma_Kh", header: "Mã khách hàng" },
      { accessorKey: "ma_Dtcn", header: "Mã đối tượng công nợ", size: 225 },
      { accessorKey: "ten_Kh", header: "Tên khách hàng" },
      { accessorKey: "dia_Chi_Kh", header: "Địa chỉ khách hàng", size: 350 },
      { accessorKey: "sdt", header: "Số điện thoại" },
      { accessorKey: "ten_Cong_Ty", header: "Tên công ty", size: 350 },
      { accessorKey: "email", header: "Email" },
      { accessorKey: "ma_Thue_Kh", header: "Mã thuế khách hàng", size: 200 },
      { accessorKey: "ten_Tinh", header: "Tỉnh/thành phố" },
      { accessorKey: "ten_Quan", header: "Quận/huyện" },
      { accessorKey: "ten_Phuong", header: "Phường/xã" },
      { accessorKey: "shipng_Type", header: "Loại giao hàng" },
      {
        accessorKey: "shiping_Vendor",
        header: "Nhà cung cấp giao hàng",
        size: 225,
      },
      {
        accessorKey: "shipping_Code",
        header: "Mã giao hàng",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Badge
              radius="sm"
              variant="dot"
              size="lg"
              color={renderedCellValue === null ? "red" : "orange"}
            >
              {renderedCellValue}
            </Badge>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "shipping_Status",
        header: "Trạng thái giao hàng",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {getValueById(
              renderedCellValue?.toString() ?? "",
              dataStatusDelivery,
              "label",
            )?.toUpperCase()}
          </Text>
        ),
        size: 225,
      },
      {
        accessorKey: "shipping_Priority",
        header: "Độ ưu tiên giao hàng",
        size: 225,
      },
      { accessorKey: "shipping_Date", header: "Ngày giao hàng" },
      { accessorKey: "shipping_Note", header: "Ghi chú giao hàng", size: 300 },
      {
        accessorKey: "shipping_Finish_Date",
        header: "Ngày hoàn thành giao hàng",
        size: 250,
      },
      {
        accessorKey: "t_Tien_Dh",
        header: "Tổng tiền đơn hàng",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text size="12.5px" fw={500}>
              {Number(renderedCellValue)?.toLocaleString()} VNĐ
            </Text>
          ) : (
            ""
          ),
        size: 200,
      },
      {
        accessorKey: "t_Ck",
        header: "Tổng chiết khấu",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text size="12.5px" fw={500}>
              {Number(renderedCellValue)?.toLocaleString()} VNĐ
            </Text>
          ) : (
            ""
          ),
      },
      {
        accessorKey: "t_Gg",
        header: "Tổng giảm giá",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text size="12.5px" fw={500}>
              {Number(renderedCellValue)?.toLocaleString()} VNĐ
            </Text>
          ) : (
            ""
          ),
      },
      {
        accessorKey: "dt_Sau_Ck",
        header: "Doanh thu sau CK",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text size="12.5px" fw={500}>
              {Number(renderedCellValue)?.toLocaleString()} VNĐ
            </Text>
          ) : (
            ""
          ),
        size: 200,
      },
      {
        accessorKey: "t_Tien_Voucher",
        header: "Tổng tiền voucher",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text size="12.5px" fw={500}>
              {Number(renderedCellValue)?.toLocaleString()} VNĐ
            </Text>
          ) : (
            ""
          ),
        size: 200,
      },
      {
        accessorKey: "t_Tien_Da_Tra",
        header: "Tổng tiền đã trả",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text size="12.5px" fw={500}>
              {Number(renderedCellValue)?.toLocaleString()} VNĐ
            </Text>
          ) : (
            ""
          ),
      },
      {
        accessorKey: "t_Tien_Con_Lai",
        header: "Tổng tiền còn lại",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text size="12.5px" fw={500}>
              {Number(renderedCellValue)?.toLocaleString()} VNĐ
            </Text>
          ) : (
            ""
          ),
      },
      {
        accessorKey: "ma_Item",
        header: "Mã sản phẩm",
        Cell: ({ renderedCellValue }) => (
          <Badge
            radius="sm"
            variant="dot"
            size="lg"
            color={renderedCellValue === null ? "red" : "blue"}
          >
            {renderedCellValue}
          </Badge>
        ),
      },
      { accessorKey: "ten_Item", header: "Tên sản phẩm", size: 350 },
      { accessorKey: "loai_Hh", header: "Loại hàng hóa" },
      { accessorKey: "so_Luong", header: "Số lượng" },
      { accessorKey: "uom", header: "Đơn vị tính" },
      {
        accessorKey: "don_Gia",
        header: "Đơn giá",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text size="12.5px" fw={500}>
              {Number(renderedCellValue)?.toLocaleString()} VNĐ
            </Text>
          ) : (
            ""
          ),
      },
      {
        accessorKey: "t_Tien_Theo_Sp",
        header: "Tổng tiền theo SP",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text size="12.5px" fw={500}>
              {Number(renderedCellValue)?.toLocaleString()} VNĐ
            </Text>
          ) : (
            ""
          ),
        size: 200,
      },
      {
        accessorKey: "tien_Ck",
        header: "Tiền chiết khấu",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text size="12.5px" fw={500}>
              {Number(renderedCellValue)?.toLocaleString()} VNĐ
            </Text>
          ) : (
            ""
          ),
      },
      {
        accessorKey: "tien_Gg",
        header: "Tiền giảm giá",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text size="12.5px" fw={500}>
              {Number(renderedCellValue)?.toLocaleString()} VNĐ
            </Text>
          ) : (
            ""
          ),
      },
      {
        accessorKey: "t_Tien_Sau_Ck_Gg",
        header: "Tiền sau CK và GG",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text size="12.5px" fw={500}>
              {Number(renderedCellValue)?.toLocaleString()} VNĐ
            </Text>
          ) : (
            ""
          ),
        size: 200,
      },
      {
        accessorKey: "pb_Km",
        header: "Phân bổ khuyến mãi",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text size="12.5px" fw={500}>
              {Number(renderedCellValue)?.toLocaleString()} VNĐ
            </Text>
          ) : (
            ""
          ),
        size: 200,
      },
      {
        accessorKey: "pb_Xin_Giam",
        header: "Phân bổ xin giảm",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text size="12.5px" fw={500}>
              {Number(renderedCellValue)?.toLocaleString()} VNĐ
            </Text>
          ) : (
            ""
          ),
        size: 200,
      },
      {
        accessorKey: "t_Tien_Sau_Pb",
        header: "Tổng tiền sau phân bổ",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text size="12.5px" fw={500}>
              {Number(renderedCellValue)?.toLocaleString()} VNĐ
            </Text>
          ) : (
            ""
          ),
        size: 250,
      },
      {
        accessorKey: "gia_Von",
        header: "Giá vốn",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text size="12.5px" fw={500}>
              {Number(renderedCellValue)?.toLocaleString()} VNĐ
            </Text>
          ) : (
            ""
          ),
      },
      {
        accessorKey: "tien_Von",
        header: "Tiền vốn",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text size="12.5px" fw={500}>
              {Number(renderedCellValue)?.toLocaleString()} VNĐ
            </Text>
          ) : (
            ""
          ),
      },
      { accessorKey: "ma_Nhom_Vt", header: "Mã nhóm VT" },
      { accessorKey: "ten_Nhom_Vt", header: "Tên nhóm VT", size: 250 },
      { accessorKey: "tg_Nguoi_Sua", header: "Thời gian sửa" },
      { accessorKey: "ma_Nguoi_Sua", header: "Mã người sửa" },
      { accessorKey: "ngay_Duyet", header: "Ngày duyệt" },
      { accessorKey: "nguoi_Duyet_Gg", header: "Người duyệt GG" },
      { accessorKey: "loai_Hd", header: "Loại HĐ" },
      { accessorKey: "xuat_Hd", header: "Xuất HĐ" },
      { accessorKey: "trang_Thai_Gv", header: "Trạng thái GV" },
      {
        accessorKey: "trang_Thai_Chung",
        header: "Trạng thái chung",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {getValueById(
              renderedCellValue?.toString() ?? "",
              dataStatusGeneral,
              "label",
            )?.toUpperCase()}
          </Text>
        ),
      },
      { accessorKey: "yc_Kt", header: "Yêu cầu KT" },
      {
        accessorKey: "tragthai_Ky_Thua_Kt",
        header: "Trạng thái kỹ thuật KT",
        Cell: ({ row }) => (
          <>
            <Badge
              color={getColorStatus(row.original.tragthai_Ky_Thua_Kt)}
              radius={"sm"}
            >
              {getValueById(
                row.original.tragthai_Ky_Thua_Kt?.toString() ?? "",
                dataStatusOption,
                "label",
              )}
            </Badge>
          </>
        ),
        size: 225,
      },
      { accessorKey: "ghichu_Kythuat", header: "Ghi chú kỹ thuật" },
      {
        accessorKey: "ma_Ctkm",
        header: "Mã CTKM",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Badge
              radius="sm"
              variant="dot"
              size="lg"
              color={renderedCellValue === null ? "red" : "violet"}
            >
              {renderedCellValue}
            </Badge>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "ngayduyet_Ctkm",
        header: "Ngày duyệt CTKM",
        Cell: ({ renderedCellValue }) => (
          <>
            {renderedCellValue &&
              formatDateTransfer(renderedCellValue as string)}
          </>
        ),
        size: 200,
      },
      {
        accessorKey: "ngaytao_Ctkm",
        header: "Ngày tạo CTKM",
        Cell: ({ renderedCellValue }) => (
          <>
            {renderedCellValue &&
              formatDateTransfer(renderedCellValue as string)}
          </>
        ),
      },
      {
        accessorKey: "ngayhieuluc_Ctkm",
        header: "Ngày hiệu lực CTKM",
        Cell: ({ renderedCellValue }) => (
          <>
            {renderedCellValue &&
              formatDateTransfer(renderedCellValue as string)}
          </>
        ),
        size: 200,
      },
      {
        accessorKey: "ngayhethan_Ctmk",
        header: "Ngày hết hạn CTMK",
        Cell: ({ renderedCellValue }) => (
          <>
            {renderedCellValue &&
              formatDateTransfer(renderedCellValue as string)}
          </>
        ),
        size: 200,
      },
      { accessorKey: "so_Ct_Dt", header: "Số CT ĐT" },
      { accessorKey: "serial_Doi_Tra", header: "Serial đổi trả" },
      { accessorKey: "tt_Doi_Tra", header: "TT đổi trả" },
      { accessorKey: "tru_Km_Nhap_Tay", header: "Trừ KM nhập tay" },
      {
        accessorKey: "tru_Theo_Quy_Dinh",
        header: "Trừ theo quy định",
        size: 200,
      },
      { accessorKey: "tru_Theo_Vat_Ly", header: "Trừ theo vật lý" },
      { accessorKey: "thanh_Tien_Sau_Tru", header: "Thành tiền sau trừ" },
      { accessorKey: "pb_Km_Dt", header: "Phân bổ KM ĐT" },
      { accessorKey: "pb_Xin_Giam_Dt", header: "Phân bổ xin giảm ĐT" },
      {
        accessorKey: "sl_Sau_Doi_Tra",
        header: "Số lượng sau đổi trả",
        size: 200,
      },
      {
        accessorKey: "t_Sau_Doi_Tra",
        header: "Tổng tiền sau đổi trả",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text size="12.5px" fw={500}>
              {Number(renderedCellValue)?.toLocaleString()} VNĐ
            </Text>
          ) : (
            ""
          ),
        size: 250,
      },
    ],
    [
      dataStatusGeneral,
      dataStatusGeneral,
      dataStatusDelivery,
      orderStatuses,
      dataStatusOption,
    ],
  );

  function getColorStatus(text: any) {
    switch (text) {
      case "TAO_MOI":
        return sky_blue.base;
      case "PHAN_CONG":
        return orange.base;
      // case "TIEP_NHAN":
      //   return "#ffab09";
      case "DANG_KIEM_TRA":
        return "#d9d02f";
      // case "DA_KIEM_TRA":
      //   return "green";
      case "TEST_MOT_PHAN":
        return "#ffcc00";
      case "TEST_LOI":
        return "red";
      case "TEST_OK":
        return "#17a2b8";
      case "HUY_PHAN_CONG":
        return "red";
      case "":
        return "green";
      // case "THANH_CONG":
      //   return green.light;
      // case "THAT_BAI":
      //   return red.base;
      case null:
        return "rgba(0, 0, 0, 0)";
      default:
        return sky_blue.base;
    }
  }

  useEffect(() => {
    //   startTransition(() => {
    const valuesList = Object.keys(rowSelectionDeferred);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelectionDeferred);
      setSelectIds(valuesList);
    }
    //  });
  }, [rowSelectionDeferred]);

  const fetchData = async () => {
    const fromDate = new Date(search.FromDate);
    const toDate = new Date(search.ToDate);

    const maxAllowedDate = new Date(fromDate);
    maxAllowedDate.setMonth(fromDate.getMonth() + 1);

    if (toDate > maxAllowedDate) {
      NotificationExtension.Fails("Chỉ được phép lọc dữ liệu trong 1 tháng !");
    } else if (!search?.MaCn || search?.MaCn?.length === 0) {
      NotificationExtension.Fails(
        "Vui lòng chọn chi nhánh trước khi tìm kiếm !",
      );
    } else {
      setIsLoading(true);
      setIsRefetching(true);
      setIsError(false);
      try {
        let url = `/api/v1/TblOrderHeader/report-sales-by-item?Skip=${
          pagination.pageIndex * pagination.pageSize
        }&Take=${pagination.pageSize}`;

        const params = new URLSearchParams();
        Object.entries(search).forEach(([key, value]) => {
          if (
            value &&
            ((typeof value === "string" && value.length > 0) ||
              (typeof value === "number" && value > 0) ||
              (Array.isArray(value) && value.length > 0))
          ) {
            params.append(key, String(value));
          }
        });

        if (OrderNumber?.length > 0) {
          url += `&OrderNumber=${OrderNumber?.toUpperCase()}`;
        }

        if (MaKh?.length > 0) {
          url += `&MaKh=${MaKh}`;
        }

        if (TenKh?.length > 0) {
          url += `&TenKh=${TenKh}`;
        }

        // if (Number(FromTongTien) > 0) {
        //   url += `&FromTongTien=${FromTongTien}`;
        // }

        // if (Number(ToTongTien) > 0) {
        //   url += `&ToTongTien=${ToTongTien}`;
        // }

        if (keySearch?.length > 0) {
          url += `&KeySearch=${keySearch?.trim()}`;
        }

        url += `&${params.toString()}`;

        const res = await repositoryMdm.get<MessageResponse<any>>(url);

        if (res && res.success) {
          const result = res.data;
          setData(result);
          setRowCount(res.totalCount);
          setIsCallFirst(true);
        } else {
          setData([]);
        }
      } catch (error) {
        setData([]);
        setIsError(true);
        console.error(error);
        return;
      } finally {
        setIsLoading(false);
        setIsRefetching(false);
        localStorage.setItem(
          keySearchSalesReportByProduct,
          JSON.stringify({ ...search, keySearch: keySearch }),
        );
      }
    }
  };

  const exportDataExcel = async () => {
    const fromDate = new Date(search.FromDate);
    const toDate = new Date(search.ToDate);

    const maxAllowedDate = new Date(fromDate);
    maxAllowedDate.setMonth(fromDate.getMonth() + 1);

    if (toDate > maxAllowedDate) {
      NotificationExtension.Fails("Chỉ được phép Export Excel trong 1 tháng !");
    } else if (!search?.MaCn || search?.MaCn?.length === 0) {
      NotificationExtension.Fails(
        "Vui lòng chọn chi nhánh trước khi Export Excel !",
      );
    } else {
      open();
      try {
        let url = `?Skip=${pagination?.pageIndex}&Take=${pagination.pageSize}`;

        const params = new URLSearchParams();
        Object.entries(search).forEach(([key, value]) => {
          if (
            value &&
            ((typeof value === "string" && value.length > 0) ||
              (Array.isArray(value) && value.length > 0))
          ) {
            params.append(key, String(value));
          }
        });

        if (OrderNumber?.length > 0) {
          url += `&OrderNumber=${OrderNumber?.toUpperCase()}`;
        }

        if (MaKh?.length > 0) {
          url += `&MaKh=${MaKh}`;
        }

        if (TenKh?.length > 0) {
          url += `&TenKh=${TenKh}`;
        }

        // if (Number(FromTongTien) > 0) {
        //   url += `&FromTongTien=${FromTongTien}`;
        // }

        // if (Number(ToTongTien) > 0) {
        //   url += `&ToTongTien=${ToTongTien}`;
        // }

        if (keySearch?.length > 0) {
          url += `&KeySearch=${keySearch?.trim()}`;
        }

        url += `&${params.toString()}`;

        const baseUrl = `/api/v1/ExportExcel/export-excel-report-sales-by-item${url}`;

        const _url = BASE_API_MDM + baseUrl;
        const token = localStorage.getItem("token");

        const response = await fetch(_url, {
          method: "GET",
          headers: {
            "Content-Type": "application/vnd.ms-excel",
            Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
          },
        });

        if (!response.ok) {
          NotificationExtension.Fails("Export Excel thất bại !");
        } else {
          const blob = await response.blob();
          const urlss = window.URL.createObjectURL(blob);
          const _name = new Date().toISOString().slice(0, 10);
          let filename = "bao_cao_ton_kho_lap_may.xlsx";
          const link = document.createElement("a");
          link.href = urlss;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
          NotificationExtension.Success("Export Excel thành công !");
        }
      } catch (error) {
        console.log(error);
      } finally {
        close();
      }
    }
  };

  const fetchDataBranch = async () => {
    const res = await getMasterOrgSelect();

    if (res) {
      const data = res
        ?.filter((item) => item.value && item.text && item.att1)
        ?.map((item) => ({
          label: `${item.att1} - ${item.text}`,
          value: item.att1?.toString(),
          id: item.value?.toString(),
        }));
      setDataBranch(data);
      changeSearchValue(
        getValueById(String(userLoginHeader?.branchId), data, "value"),
        "MaCn",
        setSearch,
      );
    }
  };

  const fetchDataInv = async () => {
    const dataBranchSearch = selectIdBranch
      .map((item) => `&BranchId=${item}`)
      .join("");

    let url = "";

    if (selectIdBranch.length > 0) {
      url =
        `/api/v1/TblDmInventory/get-list-by-branchs?Skip=0&Take=${
          Number(selectIdBranch.length) * 20
        }` + dataBranchSearch;
    } else {
      url = `/api/v1/TblDmInventory/get-all`;
    }

    const res = await repositoryDelivery.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const result = res.data;
      if (selectIdBranch.length > 0) {
        const data = result
          ?.filter((item: any) => item.code && item.name)
          ?.map((item: any) => ({
            label: `${item.code} - ${item.name}`,
            value: item.code?.toString(),
            id: item.id?.toString(),
          }));
        setDataInv(data);
      } else {
        const data = result
          ?.filter((item: any) => item.name && item.code)
          ?.map((item: any) => ({
            label: `${item.code} - ${item.name}`,
            value: item.code?.toString(),
            id: item.id?.toString(),
          }));
        setDataInv(data);
      }
    }
  };

  useEffect(() => {
    if (isCallFirst) {
      fetchData();
    }
  }, [pagination?.pageIndex, pagination?.pageSize]);

  useEffect(() => {
    Promise.all([fetchDataBranch()]);
  }, []);

  useEffect(() => {
    fetchDataInv();
  }, [selectIdBranch]);

  useEffect(() => {
    if (search?.MaCn && search?.MaCn.length > 0) {
      const dataId = dataBranch
        ?.filter((item) => search?.MaCn?.includes(item.value))
        ?.map((item) => item.id);

      setSelectIdBranch(dataId);
    } else {
      setSelectIdBranch([]);
    }
  }, [search?.MaCn]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (140 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // //Lưu ghim cột
  const getColumnPinningStorage = () => {
    const columnPinningStorage = localStorage.getItem(
      "columnPinningSaleReportByProduct",
    );
    return columnPinningStorage
      ? JSON.parse(columnPinningStorage)
      : { left: ["mrt-row-numbers"], right: ["action"] }; // Giá trị mặc định
  };

  // Lưu columnPinning vào state
  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(
    getColumnPinningStorage(),
  );
  // Hàm lưu vào localStorage
  useEffect(() => {
    localStorage.setItem(
      "columnPinningSaleReportByProduct",
      JSON.stringify(columnPinning),
    );
  }, [columnPinning]);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    positionToolbarAlertBanner: "bottom",
    enableRowNumbers: true,
    //add custom action buttons to top-left of top toolbar
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        // left: ["mrt-row-numbers", "maVt"],
        // right: ["action"],
        ...columnPinning,
      },
      columnVisibility: { id: true, phone: false, fax: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    manualPagination: true,
    onRowSelectionChange: setRowSelection,
    rowCount: rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination: pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      rowSelection,
    },
    onColumnPinningChange: (newState) => {
      setColumnPinning(newState);
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["50", "100", "200"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      style: { cursor: "pointer" },
    }),
  });

  useHotkeys([
    [
      "Enter",
      () => {
        fetchData();
      },
    ],
  ]);

  return (
    <>
      <div
        ref={headerRef}
        style={{
          width: "100%",
        }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 5 }}
          loaderProps={{
            children: (
              <Flex direction={"column"} align="center" gap="xs">
                <Loader type="dots" size={35}></Loader>
                {/* <Title size={15}> Đang upload tài liệu...</Title> */}
                <Title size={15}> Đang xử lý....</Title>
              </Flex>
            ),
          }}
        />
        <Flex justify={"space-between"} align={"center"} w={"100%"}>
          <_breadcrumb></_breadcrumb>
          <Button
            leftSection={
              <IconFileExport style={{ width: rem(14), height: rem(14) }} />
            }
            onClick={() => exportDataExcel()}
          >
            Export Excel
          </Button>
        </Flex>
        <Grid mt={10} w={"100%"}>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Nhập từ khóa"
              defaultValue={keySearch}
              onChange={(e) => setKeySearch(e.currentTarget.value)}
              leftSection={<IconSearch color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Từ ngày"
              leftSection={<IconCalendar color="#15aabf" />}
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                search.FromDate && search.FromDate.length > 0
                  ? new Date(search.FromDate)
                  : null
              }
              maxDate={
                search.ToDate && search.ToDate?.length > 0
                  ? new Date(search.ToDate)
                  : new Date()
              }
              onChange={(e) => {
                changeSearchValue(
                  formatDateNotTimeZone(e) ?? "",
                  "FromDate",
                  setSearch,
                );
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Đến ngày"
              leftSection={<IconCalendar color="#15aabf" />}
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                search.ToDate && search.ToDate.length > 0
                  ? new Date(search.ToDate)
                  : null
              }
              minDate={
                search.FromDate && search.FromDate?.length > 0
                  ? new Date(search.FromDate)
                  : undefined
              }
              onChange={(e) => {
                changeSearchValue(
                  formatDateNotTimeZone(e) ?? "",
                  "ToDate",
                  setSearch,
                );
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Mã chứng từ"
              leftSection={<IconTicket color="#15aabf" />}
              defaultValue={OrderNumber}
              onChange={(e) => setOrderNumber(e.currentTarget.value)}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Select
              size="sm"
              placeholder="Chi nhánh"
              data={dataBranch?.map((item) => ({
                label: item.label,
                value: item.value,
              }))}
              value={search?.MaCn}
              searchable
              clearable
              leftSection={<IconBrandBootstrap color="#15aabf" />}
              onChange={(e) => {
                changeSearchValue(e ? e : "", "MaCn", setSearch);
              }}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Select
              size="sm"
              placeholder="Mã kho"
              searchable
              clearable
              data={dataInv?.map((item) => ({
                label: item.label,
                value: item.value,
              }))}
              value={search?.MaKho}
              onChange={(e) => {
                changeSearchValue(e ? e : "", "MaKho", setSearch);
              }}
              leftSection={<IconBuildingWarehouse size={20} color="#15aabf" />}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Mã khách hàng"
              leftSection={<IconUserCode color="#15aabf" />}
              defaultValue={MaKh}
              onChange={(e) => setMaKh(e.currentTarget.value)}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Tên khách hàng"
              leftSection={<IconUserEdit color="#15aabf" />}
              defaultValue={TenKh}
              onChange={(e) => setTenKh(e.currentTarget.value)}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Mã nhân viên kinh doanh"
              leftSection={<IconUserCheck color="#15aabf" />}
              defaultValue={MaNvkd}
              onChange={(e) => setMaNvkd(e.currentTarget.value)}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Trạng thái đơn hàng"
              clearable
              leftSection={<IconStatusChange color="#15aabf" />}
              data={orderStatuses}
              value={search?.TrangThaiHd}
              onChange={(e) =>
                changeSearchValue(e ? e : "", "TrangThaiHd", setSearch)
              }
            />
          </Grid.Col>
          {/* <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <NumberInput
              placeholder="Tổng tiền đơn hàng từ"
              leftSection={<IconRulerMeasure color="#15aabf" />}
              thousandSeparator=","
              hideControls
              defaultValue={Number(FromTongTien)}
              min={0}
              allowNegative={false}
              onChange={(e) => setFromTongTien(Number(e))}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <NumberInput
              placeholder="Tổng tiền đơn hàng đến"
              leftSection={<IconRulerMeasure color="#15aabf" />}
              thousandSeparator=","
              hideControls
              defaultValue={Number(ToTongTien)}
              min={0}
              allowNegative={false}
              onChange={(e) => setToTongTien(Number(e))}
            />
          </Grid.Col> */}
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Button
              onClick={() => fetchData()}
              leftSection={<IconSearch size={14} />}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </>
  );
};

export default SalesReportByProduct;
